const INVITE_WELCOME_KEY = 'bark_invite_welcome';
const INVITE_WELCOME_MAX_AGE_MS = 60 * 60 * 1000;

/** Remember that an invitee has just set their password. */
export function markInviteWelcome(): void {
    try {
        localStorage.setItem(INVITE_WELCOME_KEY, String(Date.now()));
    } catch {
        // Storage can be unavailable (for example, when browser privacy settings
        // block it). The sign-in flow must still continue without the welcome.
    }
}

/**
 * Consume the one-time invite welcome, keeping it for at most 60 minutes.
 * Removal is attempted even when reading fails or the value is not fresh.
 */
export function consumeInviteWelcome(now = Date.now()): boolean {
    let value: string | null = null;
    let readFailed = false;

    try {
        value = localStorage.getItem(INVITE_WELCOME_KEY);
    } catch {
        readFailed = true;
    }

    try {
        localStorage.removeItem(INVITE_WELCOME_KEY);
    } catch {
        return false;
    }

    if (readFailed || value === null || value.trim() === '') return false;
    const markedAt = Number(value);
    if (!Number.isFinite(markedAt)) return false;

    const age = now - markedAt;
    return age >= 0 && age < INVITE_WELCOME_MAX_AGE_MS;
}
